import { SingleSelectField } from "@dgs/core";
import { FC } from "react";
import { ConsentType } from "../shared/types/consent";

interface Props {
	label: string;
	name: string;
}

const consentTypeOptions: ConsentType[] = ["dataPrivacy", "marketing", "termsOfUse"];

export const defaultConsentType: ConsentType = consentTypeOptions[0];

export const ConsentTypeSelectField: FC<Props> = ({ label, name }) => {
	return (
		<SingleSelectField
			label={label}
			name={name}
			options={consentTypeOptions}
			getLabel={String}
			getValue={String}
			required
		/>
	);
};
